import {Box} from '../../../../components/core/view';
import {CustomText} from '../../../../components/core/text';
import React from 'react';
import {styles} from './styles';
import {useColorThemeType} from '../../../../appStyles/hooks/theme';

interface LocationInStoreProps {
  category?: string;
}

const LocationInStore: React.FC<LocationInStoreProps> = props => {
  const theme = useColorThemeType('main');
  return (
    <Box
      style={[
        styles.bodyContainer,
        {backgroundColor: theme?.background.yellow[100]},
      ]}>
      <CustomText
        style={[styles.locationTypo, {color: theme?.text.blue[300]}]}
        numberOfLines={1}>
        {props?.category}
      </CustomText>
    </Box>
  );
};

export default React.memo(LocationInStore);
